import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { Image } from "../../AbstractElements";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { setToggleSidebar } from "../../Redux-Toolkit/Reducers/LayoutSlice";
import { dynamicImage } from "../../Service/DynamicImage";
import NavMenu from "./NavMenu";
import Searchbar from "./Searchbar";
import { AlignCenter } from "react-feather";

const Header = () => {
  const { toogleSidebar, scroll } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  return (
    <div className={`page-header ${toogleSidebar ? "close_icon" : ""} ${scroll ? "d-none" : "d-block"}`}>
      <Row className="header-wrapper m-0">
        <Col xs="auto" className="header-logo-wrapper p-0">
          <div className="logo-wrapper">
            <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
              <Image className="image-fluid" src={dynamicImage("logo/logo-w.png")} alt="" />
            </Link>
          </div>
          <div className="toggle-sidebar">
            <AlignCenter onClick={() => dispatch(setToggleSidebar())} />
          </div>
        </Col>
        <Searchbar />
        <Col xs="auto" className="nav-right pull-right right-header p-0 ms-auto">
          <NavMenu />
        </Col>
      </Row>
    </div>
  );
};

export default Header;
